import { extend } from 'vee-validate';

extend('min_number', {
    validate(value, { min }: any) {
        return value >= min;
    },
    params: ['min'],
    message: 'The {_field_} field must be minimum {min}'
});
